import { CollabInput } from "@contracts/collab";

export function defineIsCollabDraft(collab: CollabInput): boolean {
  return !collab.readyToPost && !collab.postedToCreators;
}
